/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Resend_Invitation_TitleInputs */

const en_users_resend_invitation_title = /** @type {(inputs: Users_Resend_Invitation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend invitation?`)
};

const pt_br2_users_resend_invitation_title = /** @type {(inputs: Users_Resend_Invitation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar convite?`)
};

/**
* | output |
* | --- |
* | "Resend invitation?" |
*
* @param {Users_Resend_Invitation_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_resend_invitation_title = /** @type {((inputs?: Users_Resend_Invitation_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Resend_Invitation_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_resend_invitation_title(inputs)
	return pt_br2_users_resend_invitation_title(inputs)
});